
import { Review } from './../shared/review.model';

import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { Recipe } from './recipe.model';
import { Ingredient } from '../shared/ingredient.model';

import { ShoppingListService } from '../shopping-list/shopping-list.service';
import { ReviewsService } from '../shared/reviews.service';


@Injectable()
export class RecipeService {
  recipesChanged = new Subject<Recipe[]>();
  
  

  private recipes: Recipe[] = [];
  rev : Review[] = []
  
  

  constructor(private slService: ShoppingListService ) {}

  getRecipes() {
    return this.recipes.slice();
  }
  setRecipe(recipe : Recipe[]){
    this.recipes = recipe ;
    this.recipesChanged.next(this.recipes.slice())

  }

  getRecipe(index: number) {
    return this.recipes[index];
  }
  

  addIngredientsToShoppingList(ingredients: Ingredient[]) {
    this.slService.addIngredients(ingredients);
  }
  addreview( index : number , review : Review){
    
    this.getRecipe(index).reviews.push(review)
    console.log(this.getRecipe(index).reviews);

  }
  
  

  addRecipe(recipe: Recipe) {
    this.recipes.push(recipe);
    this.recipesChanged.next(this.recipes.slice());
  }

  updateRecipe(index: number, newRecipe: Recipe) {
    this.recipes[index] = newRecipe;
    this.recipesChanged.next(this.recipes.slice());
  }


  deleteRecipe(index: number) {
    this.recipes.splice(index, 1);
    this.recipesChanged.next(this.recipes.slice());
  }
  
  
}
